"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const contexts_1 = require("@App/contexts");
const WizardBackButton_1 = __importDefault(require("@Components/WizardFlow/WizardBackButton"));
const WizardNextButton_1 = __importDefault(require("@Components/WizardFlow/WizardNextButton"));
const WizardNavigationBarLayout_1 = __importDefault(require("@Components/WizardFlow/WizardNavigationBarLayout"));
const ModalPortal_1 = __importDefault(require("@Components/Popups/ModalPortal"));
const mobx_react_1 = require("mobx-react");
const ClaimNoPublishersPopup_1 = __importDefault(require("@Components/ClaimComponents/ClaimNoPublishersPopup"));
const ClaimConfirmationPopup_1 = __importDefault(require("@Components/ClaimComponents/ClaimConfirmationPopup"));
const OverclaimWarningStep_1 = __importDefault(require("@Components/CreateWorkBottomNavs/ConfirmSubmission/OverclaimWarningStep"));
const WizardSubmitButton_1 = __importDefault(require("@Components/WizardFlow/WizardSubmitButton"));
const ClaimWizardNavigationBar = () => {
    const { workStore, wizardFlowStore, userStore, claimToolStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const [modalIsOpen, setModalIsOpen] = (0, react_1.useState)(false);
    const [submissionLoading, setSubmissionLoading] = (0, react_1.useState)(false);
    const showSubmitButton = wizardFlowStore.currentIndex === wizardFlowStore.flowLength - 2;
    const showNavBar = wizardFlowStore.currentIndex > 0 && wizardFlowStore.currentIndex < wizardFlowStore.flowLength - 1;
    const onSubmitButtonPressed = () => {
        setModalIsOpen(true);
    };
    const onOverclaimWarningConfirm = () => {
        workStore.setOverclaimWarningOpen(false);
        showSubmitButton ? onSubmitButtonPressed() : wizardFlowStore.advanceIndex();
    };
    const LeftContent = (react_1.default.createElement(react_1.default.Fragment, null,
        wizardFlowStore.currentIndex === 0 && react_1.default.createElement("div", { className: 'invisible-alignment-div' }),
        wizardFlowStore.currentIndex > 0 && react_1.default.createElement(WizardBackButton_1.default, null)));
    const MiddleContent = react_1.default.createElement(react_1.default.Fragment, null);
    const RightContent = (react_1.default.createElement(react_1.default.Fragment, null, wizardFlowStore.currentIndex > 0 && (react_1.default.createElement(react_1.default.Fragment, null, showSubmitButton ? (react_1.default.createElement(WizardSubmitButton_1.default, { onSubmitButtonPressed: onSubmitButtonPressed, buttonText: 'Claim' })) : (react_1.default.createElement(WizardNextButton_1.default, { disabled: !workStore.wizardStepIsValid }))))));
    const submitClaim = () => __awaiter(void 0, void 0, void 0, function* () {
        setSubmissionLoading(true);
        const updatedClaimSubmitted = yield claimToolStore.submitClaim();
        workStore.setWorkDraftToLocal(updatedClaimSubmitted);
        setSubmissionLoading(false);
        setModalIsOpen(false);
        wizardFlowStore.advanceIndex();
    });
    return (react_1.default.createElement(react_1.default.Fragment, null,
        showNavBar && (react_1.default.createElement(WizardNavigationBarLayout_1.default, { leftContent: LeftContent, middleContent: MiddleContent, rightContent: RightContent })),
        react_1.default.createElement(ModalPortal_1.default, { isOpen: claimToolStore.invalidPublishers },
            react_1.default.createElement(ClaimNoPublishersPopup_1.default, { closeModal: () => {
                    claimToolStore.setInvalidPublishers(false);
                } })),
        react_1.default.createElement(ModalPortal_1.default, { isOpen: modalIsOpen },
            react_1.default.createElement(ClaimConfirmationPopup_1.default, { closeModal: () => setModalIsOpen(false), isInternal: userStore.isInternal, submissionLoading: submissionLoading, submitClaim: submitClaim })),
        react_1.default.createElement(ModalPortal_1.default, { isOpen: workStore.overclaimWarningOpen },
            react_1.default.createElement(OverclaimWarningStep_1.default, { onClickConfirm: onOverclaimWarningConfirm, onClickCancel: () => workStore.setOverclaimWarningOpen(false) }))));
};
exports.default = (0, mobx_react_1.observer)(ClaimWizardNavigationBar);
